import { action, computed, observable } from 'mobx';

import httpFacade from 'http/httpFacade';
import Log from 'helpers/log';
import {
  FeedbackDishGroupReport,
  FeedbackDishGroupsReportReqParams,
} from 'http/Api/Feedback/types';
import { PromiseService } from 'services/PromiseService';

import { SortProperty } from '../types';

class FeedbackDishGroupsReportStore {
  @observable report: FeedbackDishGroupReport[] = [];
  @observable sortProperty: SortProperty | null = null;

  @observable private _promiseService = new PromiseService();

  @action
  getReport = async (params: FeedbackDishGroupsReportReqParams) => {
    try {
      const { data } = await this._promiseService.add(() =>
        httpFacade.feedback.fetchDishGroupsReport(params),
      );

      this.report = data;
    } catch (error) {
      Log.warn(error);
    }
  };

  @action.bound
  changeSortProperty(sortProperty: SortProperty | null) {
    this.sortProperty = sortProperty;
  }

  @computed
  get loading() {
    return this._promiseService.isPending || !this._promiseService.isCompleted;
  }
}

export default FeedbackDishGroupsReportStore;
